namespace TabAurous.HR {
    export interface LeavePolicyForm {
        LeavePolicyCode: Serenity.StringEditor;
        LeaveTypes: LeavePolicyDetailsEditor;
    }

    export class LeavePolicyForm extends Serenity.PrefixedContext {
        static formKey = 'HR.LeavePolicy';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LeavePolicyForm.init)  {
                LeavePolicyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = LeavePolicyDetailsEditor;

                Q.initFormType(LeavePolicyForm, [
                    'LeavePolicyCode', w0,
                    'LeaveTypes', w1
                ]);
            }
        }
    }
}
